import axios from "axios";
import { baseURL } from "./constants";

const config = { baseURL: baseURL };
export const axiosInstance = axios.create(config);

// ! proxy url "proxy": "http://127.0.0.1:8000"
